import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FinancialDataService } from './../../../services/financialData.service';
import { environment } from '../../../../environments/environment';

import * as _ from 'lodash';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyMasterService } from '../../../services/companymaster.service';
import { ChatbotService } from 'src/app/services/chatbot.service';

declare var $: any;
declare var Chart: any;

@Component({
  selector: 'app-key-ratios',
  templateUrl: './keyRatios.component.html',
  styleUrls: ['./keyRatios.component.css'],
})
export class KeyRatiosComponent implements OnInit, AfterViewInit {
  earningsRatiosQuarterlyChart: Object;
  earningsRatiosYearlyChart: Object;
  marginRatiosQuarterlyChart: object;
  marginRatiosYearlyChart: object;
  // growthRatiosQuarterlyChart: object;
  growthRatiosYearlyChart: object;
  returnsRatiosYearlyChart: object;

  quarterlyKeyRatiosData: any;
  yearlyKeyRatiosData: any;
  companyFinancialYearFromMonthGlobel: any;
  isCompanyListed: any;
  isKeyRatios: any;


  keyRatiosNewData: any;

  // Feature flag — driven by environment.useFinancialExtractAPI
  useNewApi: boolean = environment.useFinancialExtractAPI;

  _keyRatiosFetchInProgress = false;

  // ── FMP Key Ratios (new API) display data ─────────────────────────────────
  krFmpData: any = null;
  krEarningsDates: string[] = [];
  krEarningsRows: any[] = [];
  krMarginsDates: string[] = [];
  krMarginsRows: any[] = [];
  krGrowthDates: string[] = [];
  krGrowthRows: any[] = [];
  krReturnDates: string[] = [];
  krReturnRows: any[] = [];

  readonly krFieldLabels: { [key: string]: string } = {
    revenue: 'Revenue',
    net_income: 'Net Income',
    operating_income: 'Operating Income',
    gross_margin: 'Gross Margin',
    operating_margin: 'Operating Margin',
    net_margin: 'Net Profit Margin',
    ebitda_margin: 'EBITDA Margin',
    operatingProfitMargin: 'Operating Profit Margin',
    netProfitMargin: 'Net Profit Margin',
    ebitdaMargin: 'EBITDA Margin',
    returnOnEquity: 'Return on Equity (ROE)',
    returnOnAssets: 'Return on Assets (ROA)',
    returnOnCapitalEmployed: 'ROCE',
    revenueGrowth: 'Revenue Growth',
    earningGrowth: 'Earnings Growth',
    grossProfitRatio: 'Gross Profit Ratio',
  };

  constructor(private chatbotService: ChatbotService,
    private financialDataService: FinancialDataService, private modalService: NgbModal, private companyMasterService: CompanyMasterService) { }

  ngOnInit() {
    //  
    // $("body").removeClass("dashboard-page");
    $("body").addClass("dashboard-page dark-theme");
    //console.log("init, keyRatiosComponent", this.isCompanyListed);
    this.isCompanyListed = localStorage.getItem("isCompanyListed")
    this.isKeyRatios = localStorage.getItem("isKeyRatios")
    if (this.isCompanyListed != "false" && this.isKeyRatios != "false") {
      // this.getQuarterlyTrendEarningsRatios();
    }
    this.getKeyRatios()
  }

  ngAfterViewInit() { }

  // getQuarterlyTrendEarningsRatios() {
  //   this.companyMasterService.getCompanyList().then((company) => {
  //     try {
  //       if (this.isCompanyListed != 'false') {
  //         var self = this;
  //         this.financialDataService
  //           .getLastFiveQuatersKeyRatios()
  //           .then((responseData) => {
  //             //
  //             if (responseData.status == 0) {
  //               var count = 0;
  //               if (
  //                 responseData.keyRatios != null &&
  //                 _.size(responseData.keyRatios) > 0
  //               ) {
  //                 //
  //                 this.quarterlyKeyRatiosData = _.filter(
  //                   responseData.keyRatios
  //                 );
  //                 this.quarterlyKeyRatiosData.forEach((element) => {
  //                   _.remove(element.financialData, function (a: any) {
  //                     return a.Type == 'C';
  //                   });
  //                 });
  //                 var quaterLabel = [];
  //                 var epsData = [];
  //                 var cepsData = [];
  //                 var dpsData = [];
  //                 _.forEach(this.quarterlyKeyRatiosData, function (value) {
  //                   //  qr_EPS_BASIC
  //                   // epsData.push(value.financialData[0].qr_EPSABS);
  //                   epsData.push(value.financialData[0].qr_EPS_BASIC);

  //                   var financialQuater = value._id.toString();
  //                   var year = financialQuater.substr(0, 4);
  //                   var quater = financialQuater.substr(4, 2);
  //                   var companyFinancialYearFromyear;
  //                   var companyFinancialYearFromMonth;

  //                   if (company.status == 0) {
  //                     if (company.companyData.FinancialYearFrom) {
  //                       companyFinancialYearFromyear =
  //                         company.companyData.FinancialYearFrom;
  //                       var d = new Date(companyFinancialYearFromyear);
  //                       companyFinancialYearFromMonth = d.getMonth() + 1;
  //                       self.companyFinancialYearFromMonthGlobel =
  //                         companyFinancialYearFromMonth;
  //                     }
  //                   }

  //                   if (companyFinancialYearFromMonth == 1) {
  //                     switch (quater) {
  //                       case '03':
  //                         quater = 'Q1';
  //                         break;
  //                       case '06':
  //                         quater = 'Q2';
  //                         break;
  //                       case '09':
  //                         quater = 'Q3';
  //                         break;
  //                       case '12':
  //                         quater = 'Q4';
  //                         break;
  //                       default:
  //                         break;
  //                     }
  //                   } else if (companyFinancialYearFromMonth == 7) {
  //                     switch (quater) {
  //                       case '09':
  //                         quater = 'Q1';
  //                         break;
  //                       case '12':
  //                         quater = 'Q2';
  //                         break;
  //                       case '03':
  //                         quater = 'Q3';
  //                         //   year = (year - 1).toString();
  //                         break;
  //                       case '06':
  //                         quater = 'Q4';
  //                         //    year = (year - 1).toString();
  //                         break;
  //                       default:
  //                         break;
  //                     }
  //                   } else {
  //                     switch (quater) {
  //                       case '03':
  //                         quater = 'Q4';
  //                         // year = (year - 1).toString();
  //                         break;
  //                       case '06':
  //                         quater = 'Q1';
  //                         break;
  //                       case '09':
  //                         quater = 'Q2';
  //                         break;
  //                       case '12':
  //                         quater = 'Q3';
  //                         break;
  //                       default:
  //                         break;
  //                     }
  //                   }

  //                   quaterLabel.push(quater + ' ' + year);
  //                   // quaterLabel.push(value._id);
  //                 });
  //                 //console.log("this.quarterlyKeyRatiosData", this.quarterlyKeyRatiosData)
  //                 //
  //                 this.earningsRatiosQuarterlyChart = {
  //                   chart: {
  //                     type: 'spline',
  //                     zoomType: 'xy',
  //                     animation: {
  //                       enabled: false,
  //                     },
  //                     renderTo: 'earningsRatiosQuartelyDataSection',
  //                   },
  //                   title: {
  //                     text: '',
  //                   },
  //                   credits: {
  //                     enabled: false,
  //                   },
  //                   yAxis: {
  //                     title: {
  //                       text: false,
  //                     },
  //                   },

  //                   xAxis: {
  //                     categories: quaterLabel,
  //                     tickInterval: 1,
  //                   },
  //                   plotOptions: {
  //                     series: {
  //                       color: '#00ff00',
  //                     },
  //                   },
  //                   series: [
  //                     {
  //                       name: 'BASIC_EPS',
  //                       data: epsData,
  //                       color: '#00ff00',
  //                     },
  //                     {
  //                       name: 'CEPS',
  //                       data: cepsData,
  //                       color: '#37669e',
  //                     },
  //                     {
  //                       name: 'DPS',
  //                       data: dpsData,
  //                       color: '#2c1eae',
  //                     },
  //                   ],
  //                 };
  //               }
  //             } else {
  //             }
  //             $('.widget_kr').removeClass('active');
  //             $('#earningsRatiosQuartelyTrend').addClass('active');
  //             $('#earningsRatiosQuartelyDataSection').css('display', 'block');
  //             $('#earningsRatiosYearlyDataSection').css('display', 'none');
  //           });
  //       }
  //     } catch (error) { }
  //   });
  // }

  getAnnualTrendEarningsRatios() {
    if (this.isKeyRatios != 'false') {
      try {
        this.financialDataService
          .getLastFiveYearsKeyRatios()
          .then((responseData) => {
            //
            var self = this;
            if (responseData.status == 0) {
              var count = 0;
              if (
                responseData.keyRatios != null &&
                _.size(responseData.keyRatios) > 0
              ) {
                //
                this.yearlyKeyRatiosData = _.filter(responseData.keyRatios);
                this.yearlyKeyRatiosData.forEach((element) => {
                  _.remove(element.financialData, function (a: any) {
                    return a.Type == 'C';
                  });
                });
                var yearLabel = [];
                var epsData = [];
                var cepsData = [];
                var dpsData = [];
                _.forEach(this.yearlyKeyRatiosData, function (value) {
                  //
                  epsData.push(value.financialData[0].fr_Reported_EPS);
                  cepsData.push(value.financialData[0].fr_CEPS);
                  dpsData.push(value.financialData[0].fr_DPS);

                  var financialQuater = value._id.toString();
                  var year = financialQuater.substr(0, 4);
                  var quater = financialQuater.substr(4, 2);
                  if (self.companyFinancialYearFromMonthGlobel == 1) {
                    switch (quater) {
                      case '03':
                        quater = 'Q1';
                        break;
                      case '06':
                        quater = 'Q2';
                        break;
                      case '09':
                        quater = 'Q3';
                        break;
                      case '12':
                        quater = 'Q4';
                        break;
                      default:
                        break;
                    }

                    yearLabel.push('December ' + year);
                    value.FinancialQuater = 'December ' + year;
                  } else if (self.companyFinancialYearFromMonthGlobel == 7) {
                    switch (quater) {
                      case '09':
                        quater = 'Q1';
                        break;
                      case '12':
                        quater = 'Q2';
                        break;
                      case '03':
                        quater = 'Q3';
                        //   year = (year - 1).toString();
                        break;
                      case '06':
                        quater = 'Q4';
                        //    year = (year - 1).toString();
                        break;
                      default:
                        break;
                    }

                    yearLabel.push('June ' + year);
                    value.FinancialQuater = 'June ' + year;
                  } else {
                    switch (quater) {
                      case '03':
                        quater = 'Q4';
                        // year = (year - 1).toString();
                        break;
                      case '06':
                        quater = 'Q1';
                        break;
                      case '09':
                        quater = 'Q2';
                        break;
                      case '12':
                        quater = 'Q3';
                        break;
                      default:
                        break;
                    }
                    yearLabel.push('March ' + year);
                    value.FinancialQuater = 'March ' + year;
                  }

                  // yearLabel.push("March " + year);
                  // yearLabel.push(value._id);
                });
                //
                this.earningsRatiosYearlyChart = {
                  chart: {
                    type: 'spline',
                    zoomType: 'xy',
                    animation: {
                      enabled: false,
                    },
                    renderTo: 'earningsRatiosYearlyDataSection',
                    // width: 700
                  },
                  title: {
                    text: '',
                  },
                  credits: {
                    enabled: false,
                  },
                  yAxis: {
                    title: {
                      text: false,
                    },
                  },
                  xAxis: {
                    categories: yearLabel,
                    tickInterval: 1,
                  },
                  plotOptions: {
                    series: {
                      color: '#00ff00',
                    },
                  },
                  series: [
                    {
                      name: 'BASIC_EPS',
                      data: epsData,
                      color: '#00ff00',
                    },
                    {
                      name: 'CEPS',
                      data: cepsData,
                      color: '#37669e',
                    },
                    {
                      name: 'DPS',
                      data: dpsData,
                      color: '#2c1eae',
                    },
                  ],
                };
              }
            } else {
            }
            $('.widget_kr').removeClass('active');
            $('#earningsRatiosAnnualTrend').addClass('active');
            $('#earningsRatiosQuartelyDataSection').css('display', 'none');
            $('#earningsRatiosYearlyDataSection').css('display', 'block');
          });
      } catch (error) { }
    }
  }

  // getQuarterlyTrendMarginRatios() {
  //   if (this.isKeyRatios != 'false') {
  //     try {
  //       if (this.isCompanyListed != 'false') {
  //         this.financialDataService
  //           .getLastFiveQuatersKeyRatios()
  //           .then((responseData) => {
  //             //
  //             var self = this;
  //             if (responseData.status == 0) {
  //               var count = 0;
  //               if (
  //                 responseData.keyRatios != null &&
  //                 _.size(responseData.keyRatios) > 0
  //               ) {
  //                 //
  //                 this.quarterlyKeyRatiosData = _.filter(
  //                   responseData.keyRatios
  //                 );
  //                 this.quarterlyKeyRatiosData.forEach((element) => {
  //                   _.remove(element.financialData, function (a: any) {
  //                     return a.Type == 'C';
  //                   });
  //                 });
  //                 var quaterLabel = [];
  //                 var ebidtaData = [];
  //                 var pbitData = [];
  //                 var patData = [];
  //                 _.forEach(this.quarterlyKeyRatiosData, function (value) {
  //                   //

  //                   // ebidtaData.push(value.financialData[0].qr_OPERATING_PROFIT_MARGIN);
  //                   // patData.push(value.financialData[0].qr_NET_PROFIT_MARGIN);
  //                   ebidtaData.push(value.financialData[0].qr_PBIDTMEXOI);
  //                   patData.push(value.financialData[0].qr_PATM);

  //                   var financialQuater = value._id.toString();
  //                   var year = financialQuater.substr(0, 4);
  //                   var quater = financialQuater.substr(4, 2);
  //                   if (self.companyFinancialYearFromMonthGlobel == 1) {
  //                     switch (quater) {
  //                       case '03':
  //                         quater = 'Q1';
  //                         break;
  //                       case '06':
  //                         quater = 'Q2';
  //                         break;
  //                       case '09':
  //                         quater = 'Q3';
  //                         break;
  //                       case '12':
  //                         quater = 'Q4';
  //                         break;
  //                       default:
  //                         break;
  //                     }
  //                   } else if (self.companyFinancialYearFromMonthGlobel == 7) {
  //                     switch (quater) {
  //                       case '09':
  //                         quater = 'Q1';
  //                         break;
  //                       case '12':
  //                         quater = 'Q2';
  //                         break;
  //                       case '03':
  //                         quater = 'Q3';
  //                         //   year = (year - 1).toString();
  //                         break;
  //                       case '06':
  //                         quater = 'Q4';
  //                         //    year = (year - 1).toString();
  //                         break;
  //                       default:
  //                         break;
  //                     }
  //                   } else {
  //                     switch (quater) {
  //                       case '03':
  //                         quater = 'Q4';
  //                         // year = (year - 1).toString();
  //                         break;
  //                       case '06':
  //                         quater = 'Q1';
  //                         break;
  //                       case '09':
  //                         quater = 'Q2';
  //                         break;
  //                       case '12':
  //                         quater = 'Q3';
  //                         break;
  //                       default:
  //                         break;
  //                     }
  //                   }

  //                   quaterLabel.push(quater + ' ' + year);
  //                   // quaterLabel.push(value._id);
  //                 });
  //                 //
  //                 this.marginRatiosQuarterlyChart = {
  //                   chart: {
  //                     type: 'spline',
  //                     zoomType: 'xy',
  //                     animation: {
  //                       enabled: false,
  //                     },
  //                     renderTo: 'marginRatiosQuartelyDataSection',
  //                   },
  //                   title: {
  //                     text: '',
  //                   },
  //                   credits: {
  //                     enabled: false,
  //                   },
  //                   yAxis: {
  //                     title: {
  //                       // text: 'Margin %'
  //                       text: false,
  //                     },
  //                   },

  //                   xAxis: {
  //                     categories: quaterLabel,
  //                     tickInterval: 1,
  //                   },
  //                   plotOptions: {
  //                     series: {
  //                       color: '#00ff00',
  //                     },
  //                   },

  //                   series: [
  //                     {
  //                       name: 'EBIDTA',
  //                       data: ebidtaData,
  //                       color: '#00ff00',
  //                     },
  //                     {
  //                       name: 'PBIT',
  //                       data: pbitData,
  //                       color: '#37669e',
  //                     },
  //                     {
  //                       name: 'PAT',
  //                       data: patData,
  //                       color: '#2c1eae',
  //                     },
  //                   ],
  //                 };
  //               }
  //             } else {
  //             }
  //             $('.widget_kr').removeClass('active');
  //             $('#marginRatiosQuartelyTrend').addClass('active');
  //             $('#marginRatiosQuartelyDataSection').css('display', 'block');
  //             $('#marginRatiosYearlyDataSection').css('display', 'none');
  //           });
  //       }
  //     } catch (error) { }
  //   }
  // }

  getAnnualTrendMarginRatios() {
    if (this.isKeyRatios != 'false') {
      try {
        this.financialDataService
          .getLastFiveYearsKeyRatios()
          .then((responseData) => {
            //
            var self = this;
            if (responseData.status == 0) {
              var count = 0;
              if (
                responseData.keyRatios != null &&
                _.size(responseData.keyRatios) > 0
              ) {
                //
                this.yearlyKeyRatiosData = _.filter(responseData.keyRatios);
                this.yearlyKeyRatiosData.forEach((element) => {
                  _.remove(element.financialData, function (a: any) {
                    return a.Type == 'C';
                  });
                });
                var yearLabel = [];
                var ebidtaData = [];
                var pbitData = [];
                var patData = [];
                _.forEach(this.yearlyKeyRatiosData, function (value) {
                  //
                  ebidtaData.push(value.financialData[0].fr_Core_EBITDA_Margin);
                  pbitData.push(value.financialData[0].fr_EBIT_Margin);
                  patData.push(value.financialData[0].fr_PAT_Margin);

                  var financialQuater = value._id.toString();
                  var year = financialQuater.substr(0, 4);
                  var quater = financialQuater.substr(4, 2);

                  if (self.companyFinancialYearFromMonthGlobel == 1) {
                    switch (quater) {
                      case '03':
                        quater = 'Q1';
                        break;
                      case '06':
                        quater = 'Q2';
                        break;
                      case '09':
                        quater = 'Q3';
                        break;
                      case '12':
                        quater = 'Q4';
                        break;
                      default:
                        break;
                    }

                    yearLabel.push('December ' + year);
                    value.FinancialQuater = 'December ' + year;
                  } else if (self.companyFinancialYearFromMonthGlobel == 7) {
                    switch (quater) {
                      case '09':
                        quater = 'Q1';
                        break;
                      case '12':
                        quater = 'Q2';
                        break;
                      case '03':
                        quater = 'Q3';
                        //   year = (year - 1).toString();
                        break;
                      case '06':
                        quater = 'Q4';
                        //    year = (year - 1).toString();
                        break;
                      default:
                        break;
                    }

                    yearLabel.push('June ' + year);
                    value.FinancialQuater = 'June ' + year;
                  } else {
                    switch (quater) {
                      case '03':
                        quater = 'Q4';
                        // year = (year - 1).toString();
                        break;
                      case '06':
                        quater = 'Q1';
                        break;
                      case '09':
                        quater = 'Q2';
                        break;
                      case '12':
                        quater = 'Q3';
                        break;
                      default:
                        break;
                    }
                    yearLabel.push('March ' + year);
                    value.FinancialQuater = 'March ' + year;
                  }

                  // yearLabel.push("March " + year);
                  // yearLabel.push(value._id);
                });
                //
                this.marginRatiosYearlyChart = {
                  chart: {
                    type: 'spline',
                    zoomType: 'xy',
                    animation: {
                      enabled: false,
                    },
                    renderTo: 'marginRatiosYearlyDataSection',
                  },
                  title: {
                    text: '',
                  },
                  credits: {
                    enabled: false,
                  },
                  yAxis: {
                    title: {
                      // text: 'Margin %'
                      text: false,
                    },
                  },

                  xAxis: {
                    categories: yearLabel,
                    tickInterval: 1,
                  },
                  plotOptions: {
                    series: {
                      color: '#00ff00',
                    },
                  },

                  series: [
                    {
                      name: 'EBIDTA',
                      data: ebidtaData,
                      color: '#00ff00',
                    },
                    {
                      name: 'PBIT',
                      data: pbitData,
                      color: '#37669e',
                    },
                    {
                      name: 'PAT',
                      data: patData,
                      color: '#2c1eae',
                    },
                  ],
                };
              }
            } else {
            }
            $('.widget_kr').removeClass('active');
            $('#marginRatiosAnnualTrend').addClass('active');
            $('#marginRatiosQuartelyDataSection').css('display', 'none');
            $('#marginRatiosYearlyDataSection').css('display', 'block');
          });
      } catch (error) { }
    }
  }

  getAnnualTrendGrowthRatios() {
    if (this.isKeyRatios != 'false') {
      try {
        this.financialDataService
          .getLastFiveYearsKeyRatios()
          .then((responseData) => {
            //
            var self = this;
            if (responseData.status == 0) {
              var count = 0;
              if (
                responseData.keyRatios != null &&
                _.size(responseData.keyRatios) > 0
              ) {
                //
                this.yearlyKeyRatiosData = _.filter(responseData.keyRatios);
                this.yearlyKeyRatiosData.forEach((element) => {
                  _.remove(element.financialData, function (a: any) {
                    return a.Type == 'C';
                  });
                });
                var yearLabel = [];
                var netSalesGrowthData = [];
                var patGrowthData = [];
                _.forEach(this.yearlyKeyRatiosData, function (value) {
                  //
                  netSalesGrowthData.push(
                    value.financialData[0].fr_Net_Sales_Growth
                  );
                  patGrowthData.push(value.financialData[0].fr_PAT_Growth);

                  var financialQuater = value._id.toString();
                  var year = financialQuater.substr(0, 4);
                  var quater = financialQuater.substr(4, 2);

                  if (self.companyFinancialYearFromMonthGlobel == 1) {
                    switch (quater) {
                      case '03':
                        quater = 'Q1';
                        break;
                      case '06':
                        quater = 'Q2';
                        break;
                      case '09':
                        quater = 'Q3';
                        break;
                      case '12':
                        quater = 'Q4';
                        break;
                      default:
                        break;
                    }

                    yearLabel.push('December ' + year);
                    value.FinancialQuater = 'December ' + year;
                  } else if (self.companyFinancialYearFromMonthGlobel == 7) {
                    switch (quater) {
                      case '09':
                        quater = 'Q1';
                        break;
                      case '12':
                        quater = 'Q2';
                        break;
                      case '03':
                        quater = 'Q3';
                        //   year = (year - 1).toString();
                        break;
                      case '06':
                        quater = 'Q4';
                        //    year = (year - 1).toString();
                        break;
                      default:
                        break;
                    }

                    yearLabel.push('June ' + year);
                    value.FinancialQuater = 'June ' + year;
                  } else {
                    switch (quater) {
                      case '03':
                        quater = 'Q4';
                        // year = (year - 1).toString();
                        break;
                      case '06':
                        quater = 'Q1';
                        break;
                      case '09':
                        quater = 'Q2';
                        break;
                      case '12':
                        quater = 'Q3';
                        break;
                      default:
                        break;
                    }
                    yearLabel.push('March ' + year);
                    value.FinancialQuater = 'March ' + year;
                  }

                  // yearLabel.push("March " + year);
                  // yearLabel.push(value._id);
                });
                //
                this.growthRatiosYearlyChart = {
                  chart: {
                    type: 'spline',
                    zoomType: 'xy',
                    animation: {
                      enabled: false,
                    },
                    renderTo: 'growthRatiosYearlyDataSection',
                  },
                  title: {
                    text: '',
                  },
                  credits: {
                    enabled: false,
                  },
                  yAxis: {
                    title: {
                      // text: '%'
                      text: false,
                    },
                  },

                  xAxis: {
                    categories: yearLabel,
                    tickInterval: 1,
                  },
                  plotOptions: {
                    series: {
                      color: '#00ff00',
                    },
                  },

                  series: [
                    {
                      name: 'Net Sales Growth',
                      data: netSalesGrowthData,
                      color: '#00ff00',
                    },
                    {
                      name: 'PAT Growth',
                      data: patGrowthData,
                      color: '#37669e',
                    },
                  ],
                };
              }
            } else {
            }
            $('.widget_kr').removeClass('active');
            $('#growthRatiosAnnualTrend').addClass('active');
            $('#growthRatiosQuartelyDataSection').css('display', 'none');
            $('#growthRatiosYearlyDataSection').css('display', 'block');
          });
      } catch (error) { }
    }
  }

  getAnnualTrendReturnsRatios() {
    if (this.isKeyRatios != 'false') {
      try {
        this.financialDataService
          .getLastFiveYearsKeyRatios()
          .then((responseData) => {
            //
            var self = this;
            if (responseData.status == 0) {
              var count = 0;
              if (
                responseData.keyRatios != null &&
                _.size(responseData.keyRatios) > 0
              ) {
                //
                this.yearlyKeyRatiosData = _.filter(responseData.keyRatios);
                this.yearlyKeyRatiosData.forEach((element) => {
                  _.remove(element.financialData, function (a: any) {
                    return a.Type == 'C';
                  });
                });
                var yearLabel = [];
                var roaData = [];
                var roeData = [];
                var roceData = [];
                var roicData = [];
                _.forEach(this.yearlyKeyRatiosData, function (value) {
                  //
                  roaData.push(value.financialData[0].fr_ROA);
                  roeData.push(value.financialData[0].fr_ROE);
                  roceData.push(value.financialData[0].fr_ROCE);
                  // roicData.push(value.financialData[0].fr_ROIC);

                  var financialQuater = value._id.toString();
                  var year = financialQuater.substr(0, 4);
                  var quater = financialQuater.substr(4, 2);

                  if (self.companyFinancialYearFromMonthGlobel == 1) {
                    switch (quater) {
                      case '03':
                        quater = 'Q1';
                        break;
                      case '06':
                        quater = 'Q2';
                        break;
                      case '09':
                        quater = 'Q3';
                        break;
                      case '12':
                        quater = 'Q4';
                        break;
                      default:
                        break;
                    }

                    yearLabel.push('December ' + year);
                    value.FinancialQuater = 'December ' + year;
                  } else if (self.companyFinancialYearFromMonthGlobel == 7) {
                    switch (quater) {
                      case '09':
                        quater = 'Q1';
                        break;
                      case '12':
                        quater = 'Q2';
                        break;
                      case '03':
                        quater = 'Q3';
                        //   year = (year - 1).toString();
                        break;
                      case '06':
                        quater = 'Q4';
                        //    year = (year - 1).toString();
                        break;
                      default:
                        break;
                    }

                    yearLabel.push('June ' + year);
                    value.FinancialQuater = 'June ' + year;
                  } else {
                    switch (quater) {
                      case '03':
                        quater = 'Q4';
                        // year = (year - 1).toString();
                        break;
                      case '06':
                        quater = 'Q1';
                        break;
                      case '09':
                        quater = 'Q2';
                        break;
                      case '12':
                        quater = 'Q3';
                        break;
                      default:
                        break;
                    }
                    yearLabel.push('March ' + year);
                    value.FinancialQuater = 'March ' + year;
                  }

                  // yearLabel.push("March " + year);
                  // yearLabel.push(value._id);
                });
                //
                this.returnsRatiosYearlyChart = {
                  chart: {
                    type: 'spline',
                    zoomType: 'xy',
                    animation: {
                      enabled: false,
                    },
                    renderTo: 'returnsRatiosYearlyDataSection',
                  },
                  title: {
                    text: '',
                  },
                  credits: {
                    enabled: false,
                  },
                  yAxis: {
                    title: {
                      // text: '%'
                      text: false,
                    },
                  },
                  xAxis: {
                    categories: yearLabel,
                    tickInterval: 1,
                  },
                  plotOptions: {
                    series: {
                      color: '#00ff00',
                    },
                  },
                  series: [
                    {
                      name: 'ROA',
                      data: roaData,
                      color: '#00ff00',
                    },
                    {
                      name: 'ROE',
                      data: roeData,
                      color: '#37669e',
                    },
                    {
                      name: 'ROCE',
                      data: roceData,
                      color: '#2c1eae',
                    },
                    // , {
                    //     name: 'ROIC',
                    //     data: roicData
                    // }
                  ],
                };
              }
            } else {
            }
            $('.widget_kr').removeClass('active');
            $('#returnsRatiosAnnualTrend').addClass('active');
            // $('#growthRatiosQuartelyDataSection').css('display', 'none');
            $('#returnsRatiosYearlyDataSection').css('display', 'block');
          });
      } catch (error) { }
    }
  }

  tagToogle(tabName) {
    if (this.isCompanyListed != 'false' && this.isKeyRatios != 'false') {
      if (tabName == 'earningsRatiosTab') {
        //is.getQuarterlyTrendEarningsRatios();
        // Initialize charts when switching to earnings ratios tab
        setTimeout(() => {
          this.initializeEarningsRatiosCharts();
        }, 300);
      } else if (tabName == 'marginRatiosTab') {
        //is.getQuarterlyTrendMarginRatios();
        // Initialize charts when switching to margin ratios tab
        setTimeout(() => {
          this.initializeMarginRatiosCharts();
        }, 300);
      } else if (tabName == 'growthRatiosTab') {
        // this.getQuarterlyTrendGrowthRatios();
        //is.getAnnualTrendGrowthRatios();
        // Initialize charts when switching to growth ratios tab
        setTimeout(() => {
          this.initializeGrowthRatiosCharts();
        }, 300);
      } else if (tabName == 'returnsRatiosTab') {
        //is.getAnnualTrendReturnsRatios();
        // Initialize charts when switching to returns ratios tab
        setTimeout(() => {
          this.initializeReturnsRatiosCharts();
        }, 300);
      }
    }
  }


 getKeyRatios() {
  let symbol = localStorage.getItem('Symbol') || '';

  // If symbol is missing, fetch from company master and cache it to avoid empty calls
  if (!symbol) {
    this.companyMasterService.getCompanyList().then((company) => {
      if (!company.status && company.companyData?.Symbol) {
        symbol = company.companyData.Symbol;
        localStorage.setItem('Symbol', symbol);
        this.fetchKeyRatios(symbol);
      } else {
        console.error('Symbol not available from company data, cannot load key ratios.', company);
      }
    }).catch(err => {
      console.error('Error fetching company data for symbol', err);
    });
    return;
  }

  this.fetchKeyRatios(symbol);
}

// Actual API call separated for reuse once symbol is resolved
fetchKeyRatios(symbol: string) {
  if (this._keyRatiosFetchInProgress || this.keyRatiosNewData) {
    return;
  }
  this._keyRatiosFetchInProgress = true;

  const apiCall = this.useNewApi
    ? this.chatbotService.getFmpKeyRatios(symbol)   // Financial Data Extractor API
    : this.chatbotService.getKeyRatios(symbol);      // Legacy Robocs API

  apiCall.subscribe(
    (response: any) => {
      this._keyRatiosFetchInProgress = false;
      if (this.useNewApi) {
        // FMP API: response = { status, source, data: { symbol, earnings, margins, growth_ratios, return_ratios } }
        this.krFmpData = (response && response.data) ? response.data : response;
        this._buildKrDisplayData();
      } else {
        // Legacy Robocs API: response = { financial_ratios: { earnings_ratios, margin_ratios, ... } }
        this.keyRatiosNewData = response.financial_ratios || response;
        this.initializeEarningsRatiosCharts();
        this.initializeMarginRatiosCharts();
        this.initializeGrowthRatiosCharts();
        this.initializeReturnsRatiosCharts();
      }
    },
    error => {
      this._keyRatiosFetchInProgress = false;
      console.error('Error fetching key ratios data:', error);
    }
  );
}

// Initialize charts for Earnings Ratios
initializeEarningsRatiosCharts() {
  const self = this;
  
  // Use jQuery to ensure DOM is ready
  $(function() {
    if (typeof Chart === 'undefined') {
      console.warn('Chart.js is not loaded');
      return;
    }

    if (!self.keyRatiosNewData?.earnings_ratios) {
      return;
    }

    const quarter = self.keyRatiosNewData.earnings_ratios.quarter;
    const annual = self.keyRatiosNewData.earnings_ratios.annual;

    if (!quarter || !annual) {
      return;
    }

      // Wait a bit more to ensure tab content is visible
    setTimeout(function() {
      // Chart 1: Quarterly Earnings Ratios (all metrics)
      self.createQuarterlyEarningsChart(quarter);

      // Chart 2: Annual Earnings Ratios (all metrics)
      self.createAnnualEarningsChart(annual);
    }, 200);
  });
}

// Initialize charts for Margin Ratios
initializeMarginRatiosCharts() {
  const self = this;
  
  // Use jQuery to ensure DOM is ready
  $(function() {
    if (typeof Chart === 'undefined') {
      console.warn('Chart.js is not loaded');
      return;
    }

    if (!self.keyRatiosNewData?.margin_ratios) {
      return;
    }

    const quarter = self.keyRatiosNewData.margin_ratios.quarter;
    const annual = self.keyRatiosNewData.margin_ratios.annual;

    if (!quarter || !annual) {
      return;
    }

    // Wait a bit more to ensure tab content is visible
    setTimeout(function() {
      // Chart 1: Quarterly Margin Ratios (all metrics)
      self.createQuarterlyMarginChart(quarter);

      // Chart 2: Annual Margin Ratios (all metrics)
      self.createAnnualMarginChart(annual);
    }, 200);
  });
}

// Create Quarterly Earnings Ratios Chart
createQuarterlyEarningsChart(quarter: any) {
  const canvasElement = $('#quarterlyEarningsChart');
  if (!canvasElement.length) {
    console.warn('Canvas element not found: quarterlyEarningsChart');
    return;
  }

  const canvas = canvasElement[0] as HTMLCanvasElement;
  if (!canvas) {
    return;
  }

  // Destroy existing chart if it exists
  const existingChart = (canvas as any).chart;
  if (existingChart) {
    existingChart.destroy();
  }

  const ctx = canvas.getContext('2d');
  if (!ctx) {
    return;
  }

  try {
    const chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: ['Price to Earnings', 'Earnings per Share', 'Dividend per Share', 'Dividend Yield (%)'],
        datasets: [{
          label: 'Quarterly Earnings Ratios',
          data: [
            quarter.price_to_earnings_ratio || 0,
            quarter.earnings_per_share || 0,
            quarter.dividend_per_share || 0,
            quarter.dividend_yield_percentage || 0
          ],
          backgroundColor: [
            'rgba(54, 162, 235, 0.6)',
            'rgba(75, 192, 192, 0.6)',
            'rgba(255, 206, 86, 0.6)',
            'rgba(153, 102, 255, 0.6)'
          ],
          borderColor: [
            'rgba(54, 162, 235, 1)',
            'rgba(75, 192, 192, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(153, 102, 255, 1)'
          ],
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        legend: {
          display: true,
          position: 'top'
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem: any, data: any) {
              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel.toFixed(2);
            }
          }
        }
      }
    });

    // Store chart reference
    (canvas as any).chart = chart;
  } catch (error) {
    console.error('Error creating quarterly earnings chart:', error);
  }
}

// Create Annual Earnings Ratios Chart
createAnnualEarningsChart(annual: any) {
  const canvasElement = $('#annualEarningsChart');
  if (!canvasElement.length) {
    console.warn('Canvas element not found: annualEarningsChart');
    return;
  }

  const canvas = canvasElement[0] as HTMLCanvasElement;
  if (!canvas) {
    return;
  }

  // Destroy existing chart if it exists
  const existingChart = (canvas as any).chart;
  if (existingChart) {
    existingChart.destroy();
  }

  const ctx = canvas.getContext('2d');
  if (!ctx) {
    return;
  }

  try {
    const chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: ['Price to Earnings', 'Earnings per Share', 'Dividend per Share', 'Dividend Yield (%)'],
        datasets: [{
          label: 'Annual Earnings Ratios',
          data: [
            annual.price_to_earnings_ratio || 0,
            annual.earnings_per_share || 0,
            annual.dividend_per_share || 0,
            annual.dividend_yield_percentage || 0
          ],
          backgroundColor: [
            'rgba(54, 162, 235, 0.6)',
            'rgba(75, 192, 192, 0.6)',
            'rgba(255, 206, 86, 0.6)',
            'rgba(153, 102, 255, 0.6)'
          ],
          borderColor: [
            'rgba(54, 162, 235, 1)',
            'rgba(75, 192, 192, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(153, 102, 255, 1)'
          ],
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        legend: {
          display: true,
          position: 'top'
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem: any, data: any) {
              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel.toFixed(2);
            }
          }
        }
      }
    });

    // Store chart reference
    (canvas as any).chart = chart;
  } catch (error) {
    console.error('Error creating annual earnings chart:', error);
  }
}

// Create Quarterly Margin Ratios Chart
createQuarterlyMarginChart(quarter: any) {
  const canvasElement = $('#quarterlyMarginChart');
  if (!canvasElement.length) {
    console.warn('Canvas element not found: quarterlyMarginChart');
    return;
  }

  const canvas = canvasElement[0] as HTMLCanvasElement;
  if (!canvas) {
    return;
  }

  // Destroy existing chart if it exists
  const existingChart = (canvas as any).chart;
  if (existingChart) {
    existingChart.destroy();
  }

  const ctx = canvas.getContext('2d');
  if (!ctx) {
    return;
  }

  try {
    const chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: ['Gross Profit Margin', 'Operating Profit Margin', 'Net Profit Margin', 'EBITDA Margin'],
        datasets: [{
          label: 'Quarterly Margin Ratios',
          data: [
            quarter.gross_profit_margin || 0,
            quarter.operating_profit_margin || 0,
            quarter.net_profit_margin || 0,
            quarter.ebitda_margin || 0
          ],
          backgroundColor: [
            'rgba(54, 162, 235, 0.6)',
            'rgba(75, 192, 192, 0.6)',
            'rgba(255, 206, 86, 0.6)',
            'rgba(153, 102, 255, 0.6)'
          ],
          borderColor: [
            'rgba(54, 162, 235, 1)',
            'rgba(75, 192, 192, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(153, 102, 255, 1)'
          ],
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        legend: {
          display: true,
          position: 'top'
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem: any, data: any) {
              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel.toFixed(2);
            }
          }
        }
      }
    });

    // Store chart reference
    (canvas as any).chart = chart;
  } catch (error) {
    console.error('Error creating quarterly margin chart:', error);
  }
}

// Create Annual Margin Ratios Chart
createAnnualMarginChart(annual: any) {
  const canvasElement = $('#annualMarginChart');
  if (!canvasElement.length) {
    console.warn('Canvas element not found: annualMarginChart');
    return;
  }

  const canvas = canvasElement[0] as HTMLCanvasElement;
  if (!canvas) {
    return;
  }

  // Destroy existing chart if it exists
  const existingChart = (canvas as any).chart;
  if (existingChart) {
    existingChart.destroy();
  }

  const ctx = canvas.getContext('2d');
  if (!ctx) {
    return;
  }

  try {
    const chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: ['Gross Profit Margin', 'Operating Profit Margin', 'Net Profit Margin', 'EBITDA Margin'],
        datasets: [{
          label: 'Annual Margin Ratios',
          data: [
            annual.gross_profit_margin || 0,
            annual.operating_profit_margin || 0,
            annual.net_profit_margin || 0,
            annual.ebitda_margin || 0
          ],
          backgroundColor: [
            'rgba(54, 162, 235, 0.6)',
            'rgba(75, 192, 192, 0.6)',
            'rgba(255, 206, 86, 0.6)',
            'rgba(153, 102, 255, 0.6)'
          ],
          borderColor: [
            'rgba(54, 162, 235, 1)',
            'rgba(75, 192, 192, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(153, 102, 255, 1)'
          ],
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        legend: {
          display: true,
          position: 'top'
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem: any, data: any) {
              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel.toFixed(2);
            }
          }
        }
      }
    });

    // Store chart reference
    (canvas as any).chart = chart;
  } catch (error) {
    console.error('Error creating annual margin chart:', error);
  }
}

// Initialize charts for Growth Ratios
initializeGrowthRatiosCharts() {
  const self = this;
  
  // Use jQuery to ensure DOM is ready
  $(function() {
    if (typeof Chart === 'undefined') {
      console.warn('Chart.js is not loaded');
      return;
    }

    if (!self.keyRatiosNewData?.growth_ratios) {
      return;
    }

    const annual = self.keyRatiosNewData.growth_ratios.annual;

    if (!annual) {
      return;
    }

    // Wait a bit more to ensure tab content is visible
    setTimeout(function() {
      // Chart: Annual Growth Ratios (all metrics)
      self.createAnnualGrowthChart(annual);
    }, 200);
  });
}

// Create Annual Growth Ratios Chart
createAnnualGrowthChart(annual: any) {
  const canvasElement = $('#annualGrowthChart');
  if (!canvasElement.length) {
    console.warn('Canvas element not found: annualGrowthChart');
    return;
  }

  const canvas = canvasElement[0] as HTMLCanvasElement;
  if (!canvas) {
    return;
  }

  // Destroy existing chart if it exists
  const existingChart = (canvas as any).chart;
  if (existingChart) {
    existingChart.destroy();
  }

  const ctx = canvas.getContext('2d');
  if (!ctx) {
    return;
  }

  try {
    const chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: ['P/E Growth Ratio', 'Revenue per Share', 'Book Value per Share', 'Free Cash Flow per Share'],
        datasets: [{
          label: 'Annual Growth Ratios',
          data: [
            annual.price_to_earnings_growth_ratio || 0,
            annual.revenue_per_share || 0,
            annual.book_value_per_share || 0,
            annual.free_cash_flow_per_share || 0
          ],
          backgroundColor: [
            'rgba(54, 162, 235, 0.6)',
            'rgba(75, 192, 192, 0.6)',
            'rgba(255, 206, 86, 0.6)',
            'rgba(153, 102, 255, 0.6)'
          ],
          borderColor: [
            'rgba(54, 162, 235, 1)',
            'rgba(75, 192, 192, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(153, 102, 255, 1)'
          ],
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        legend: {
          display: true,
          position: 'top'
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem: any, data: any) {
              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel.toFixed(2);
            }
          }
        }
      }
    });

    // Store chart reference
    (canvas as any).chart = chart;
  } catch (error) {
    console.error('Error creating annual growth chart:', error);
  }
}

// Initialize charts for Returns Ratios
initializeReturnsRatiosCharts() {
  const self = this;
  
  // Use jQuery to ensure DOM is ready
  $(function() {
    if (typeof Chart === 'undefined') {
      console.warn('Chart.js is not loaded');
      return;
    }

    if (!self.keyRatiosNewData?.returns_ratios) {
      return;
    }

    const annual = self.keyRatiosNewData.returns_ratios.annual;

    if (!annual) {
      return;
    }

    // Wait a bit more to ensure tab content is visible
    setTimeout(function() {
      // Chart: Annual Returns Ratios (all metrics)
      self.createAnnualReturnsChart(annual);
    }, 200);
  });
}

// ── FMP Key Ratios: build transposed time-series display data ─────────────

private _buildKrDisplayData() {
  if (!this.krFmpData) { return; }

  const earningsArr: any[] = this.krFmpData.earnings?.annual || [];
  this.krEarningsDates = earningsArr.map((r: any) => r.date);
  this.krEarningsRows = this._krTranspose(earningsArr, ['revenue', 'operating_income', 'net_income']);

  const marginsArr: any[] = this.krFmpData.margins?.annual || [];
  this.krMarginsDates = marginsArr.map((r: any) => r.date);
  this.krMarginsRows = this._krTranspose(marginsArr, [
    'gross_margin', 'operating_margin', 'net_margin', 'ebitda_margin',
    'returnOnEquity', 'returnOnAssets', 'returnOnCapitalEmployed',
    'revenueGrowth', 'earningGrowth'
  ]);

  const growthArr: any[] = this.krFmpData.growth_ratios || [];
  this.krGrowthDates = growthArr.map((r: any) => r.date);
  this.krGrowthRows = this._krTranspose(growthArr, [
    'revenueGrowth', 'earningGrowth',
    'operatingProfitMargin', 'netProfitMargin', 'ebitdaMargin',
    'returnOnEquity', 'returnOnAssets', 'returnOnCapitalEmployed'
  ]);

  const returnsArr: any[] = this.krFmpData.return_ratios || [];
  this.krReturnDates = returnsArr.map((r: any) => r.date);
  this.krReturnRows = this._krTranspose(returnsArr, [
    'returnOnEquity', 'returnOnAssets', 'returnOnCapitalEmployed',
    'operatingProfitMargin', 'netProfitMargin', 'ebitdaMargin'
  ]);
}

private _krTranspose(data: any[], keys: string[]): any[] {
  return keys
    .filter(key => data.some((p: any) => p[key] != null))
    .map(key => {
      const row: any = { _key: key };
      data.forEach((period: any) => { row[period.date] = period[key]; });
      return row;
    });
}

formatKrValue(val: any, key: string): string {
  if (val == null) { return '—'; }
  if (typeof val !== 'number') { return String(val); }

  // Raw number values — convert to Crore
  if (key === 'revenue' || key === 'net_income' || key === 'operating_income') {
    const crore = val / 10000000;
    return crore.toLocaleString('en-IN', { maximumFractionDigits: 2 }) + ' Cr';
  }
  // Ratio (0–1) values — multiply to get %
  if (key === 'earningGrowth' || key === 'grossProfitRatio') {
    return (val * 100).toFixed(2) + '%';
  }
  // All remaining values are already in % form
  return val.toFixed(2) + '%';
}

getKrLabel(key: string): string {
  return this.krFieldLabels[key]
    || key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()).trim();
}

isKrHighlightKey(key: string): boolean {
  const highlighted = new Set([
    'revenue', 'net_income', 'net_margin', 'returnOnEquity',
    'revenueGrowth', 'returnOnAssets'
  ]);
  return highlighted.has(key);
}

// Create Annual Returns Ratios Chart
createAnnualReturnsChart(annual: any) {
  const canvasElement = $('#annualReturnsChart');
  if (!canvasElement.length) {
    console.warn('Canvas element not found: annualReturnsChart');
    return;
  }

  const canvas = canvasElement[0] as HTMLCanvasElement;
  if (!canvas) {
    return;
  }

  // Destroy existing chart if it exists
  const existingChart = (canvas as any).chart;
  if (existingChart) {
    existingChart.destroy();
  }

  const ctx = canvas.getContext('2d');
  if (!ctx) {
    return;
  }

  try {
    const chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: ['Return on Assets', 'Current Ratio', 'Quick Ratio', 'Debt to Equity Ratio'],
        datasets: [{
          label: 'Annual Returns Ratios',
          data: [
            annual.return_on_assets || 0,
            annual.current_ratio || 0,
            annual.quick_ratio || 0,
            annual.debt_to_equity_ratio || 0
          ],
          backgroundColor: [
            'rgba(54, 162, 235, 0.6)',
            'rgba(75, 192, 192, 0.6)',
            'rgba(255, 206, 86, 0.6)',
            'rgba(153, 102, 255, 0.6)'
          ],
          borderColor: [
            'rgba(54, 162, 235, 1)',
            'rgba(75, 192, 192, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(153, 102, 255, 1)'
          ],
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        legend: {
          display: true,
          position: 'top'
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem: any, data: any) {
              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel.toFixed(2);
            }
          }
        }
      }
    });

    // Store chart reference
    (canvas as any).chart = chart;
  } catch (error) {
    console.error('Error creating annual returns chart:', error);
  }
}
}
